<template>

    <div class="case-studies__page" id="content" v-if="result1 && result2">

        <div class="intro__holder background-image-holder">
            <div class="wrapper">
                <intro-component :intro="result1.caseStudyPage.data.attributes.intro.Intro" :isAnimated="true"></intro-component>
            </div>
            <span class="case-studies-background"></span>
        </div>

        <div class="marquee__holder case-studies__marquee">
            <div class="wrapper">
                <div class="case-studies__holder">
                    <div class="case-study__block" v-for="(study, index) in result2.caseStudies.data">
                        <div class="case-study__index index__holder"
                             data-gsap="divPopin"
                            data-gsap-duration="0.6"
                            data-gsap-delay="0.55"
                            >0{{index+1}}.</div>
                        <case-study :study="{
                                title: study.attributes.Title,
                                caption: study.attributes.caption,
                                slug: `/case-studies/${study.attributes.slug}`,
                                url: study.attributes.FeaturedImage?.data?.attributes?.url || null,
                                alternativeText: study.attributes.FeaturedImage?.data?.attributes?.alternativeText || study.attributes.Title,
                                id: study.id,
                                FeaturedImage: study.attributes.FeaturedImage
                            }"
                            data-gsap="divPopin"
                            data-gsap-delay="0.60"
                            data-gsap-duration="0.6">
                        </case-study>
                    </div>
                </div>
            </div>
            <div class="marquee">
                Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/Work/
            </div>
        </div>

        <div class="case-studies__work marquee__holder hire-us__holder background-image-holder">
            <div class="wrapper">
                <intro-component :intro="result1.caseStudyPage.data.attributes.HireUs" :index="1" :isAnimated="true"></intro-component>
                <button-component  :button="result1.caseStudyPage.data.attributes.Button" classes="main-accent" data-gsap="fadeIn" data-gsap-initial-scale="1" data-gsap-delay="0.4" data-gsap-duration="0.2"></button-component>
            </div>

            <div class="marquee">
                Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
            </div>
            <span class="contact-noise"></span>
            <span class="contact-background"></span>
        </div>
        <Seo :seoData="result1.caseStudyPage.data.attributes.Seo"/>
    </div>

</template>

<script lang="ts">

    import { defineComponent, ref } from 'vue'
    import gql from 'graphql-tag'

    import { useQuery } from '@vue/apollo-composable'

    import { CASE_STUDY_PAGE_QUERY } from '../graphql/case-studies-page'
    import { CASE_STUDY_BLOCK } from '../graphql/case-study-block'

    import IntroComponent from '../components/IntroComponent.vue'
    import CaseStudy from '../template-parts/case-studies/CaseStudyBlock.vue'
    import ButtonComponent from '../components/ButtonComponent.vue'

    import LongArrow from "../components/svg/LongArrow.vue"
    import BadgeIcon from "../components/svg/BadgeIcon.vue"
    import WorkSquares from "../components/svg/WorkSquares.vue"
    import WorkWord from "../components/svg/WorkWord.vue"

    import ContactSquares          from "../components/svg/ContactSquares.vue"
    import ContactQuitar          from "../components/svg/ContactQuitar.vue"

    import CaseStudiesBackground from "../components/svg/CaseStudiesBackground.vue"
    import CaseStudiesNoise from "../components/svg/CaseStudiesNoise.vue"

    import Seo from '../components/navigation/Seo.vue'

    export default defineComponent({

        components: {
            IntroComponent,
            CaseStudy,
            ButtonComponent,
            LongArrow,
            BadgeIcon,
            WorkSquares,
            WorkWord,
            ContactSquares,
            ContactQuitar,
            Seo,
            CaseStudiesBackground,
            CaseStudiesNoise
        },

        setup() {
            const homeurl: string = import.meta.env.VITE_API_URL

            const case_study_page = ref(CASE_STUDY_PAGE_QUERY)
            const case_study_block = ref(CASE_STUDY_BLOCK)

            const { result : result1 } = useQuery(case_study_page)
            const { result : result2 } = useQuery(case_study_block)

            return {
                result1,
                result2,
                homeurl,
                // selectedMember
            }

        }

    })

</script>
